var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"primary mb-5",attrs:{"block":_vm.block},on:{"click":function($event){$event.stopPropagation();return _vm.handleActionButtonAction.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }